export const LocationSeparate = (location) => {
  if (location !== "/") {
    const separate = location.split("/");
    const filterSeparete = separate.filter((data) => {
      return data !== "";
    });
    const select = filterSeparete[filterSeparete.length - 1];
    const pathCreate = select === "inmersys" ? `/${select}` : select;
    return pathCreate;
  } else {
    return null;
  }
};
